import { useCallback, useMemo, useRef } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { LoadingButton } from 'foundations-components/transitional/components/LoadingButton';
import { debounce, omit } from 'ui-addon-upgrades/utils';
import { mapPurchaseMotionApiName } from 'ui-addon-upgrades/ums/utils';
import withErrorBoundary from '../../ErrorBoundary';
import { CONTACT_SALES_BUTTON } from '../common/constants/ErrorBoundaryNames';
import { sourceKeys } from '../common/data/upgradeData/properties/sources';
import { getSource } from '../common/data/upgradeData/transformers/getPropertySource';
import { sequence } from '../contactSales/utils';
import { trackContactSalesButtonClick, trackContactSalesButtonView } from './utils';
import { useContactSalesAction } from './handleContactSalesAction';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ContactSalesButton = props => {
  const {
    onClick = () => {},
    onCancel = () => {}
  } = props;
  const upgradeDataWithApiName = useMemo(() => {
    const {
      upgradeData
    } = props;
    return Object.assign({}, upgradeData, {
      apiName: mapPurchaseMotionApiName(!upgradeData.apiName, 'ContactSalesButton', upgradeData.upgradeProduct, upgradeData.apiName),
      source: getSource({
        app: upgradeData.app,
        screen: upgradeData.screen,
        uniqueId: upgradeData.uniqueId
      }, sourceKeys.CONTACT_SALES_BUTTON)
    });
  }, [props]);
  const hasTrackedView = useRef(false);
  if (!hasTrackedView.current) {
    trackContactSalesButtonView(Object.assign({}, props, {
      upgradeData: upgradeDataWithApiName
    }));
    hasTrackedView.current = true;
  }
  const {
    executeAction,
    isLoading,
    modalElement
  } = useContactSalesAction(Object.assign({}, props, {
    onClose: onCancel,
    onTrackClick: trackContactSalesButtonClick
  }));
  const handleClick = useCallback(async () => {
    await executeAction();
    if (onClick) onClick();
  }, [executeAction, onClick]);
  const renderButton = () => {
    const CLICK_DELAY = 50;
    const debouncedHandleClick = debounce(handleClick, CLICK_DELAY);
    const onClickSequence = sequence(debouncedHandleClick, onClick);
    const propsToPass = omit(props, ['usageLimitBannerData', 'forwardedRef', 'onClick', 'upgradeData', 'allowModal', 'isAssignable', 'termId', 'additionalUnitQuantity', 'isUpgradePoint', '_textOverride', '_overrideCommunicationMethodKey', '_buttonOverride', '_overrideModalHeaderText', 'modalRoot', 'canViewNewSeats', 'ctaStyles']);
    if (props._buttonOverride) {
      return /*#__PURE__*/_jsx("div", Object.assign({
        onClick: onClickSequence,
        "data-selenium": "contact-sales-button",
        "data-test-id": "contact-sales-button-override"
      }, propsToPass, {
        children: props._buttonOverride
      }));
    } else {
      return /*#__PURE__*/_jsx(LoadingButton, {
        loading: isLoading,
        buttonRef: props.forwardedRef,
        onClick: onClickSequence,
        "data-selenium": props['data-selenium'] || 'contact-sales-button',
        "data-test-id": props['data-test-id'] || 'contact-sales-button',
        "data-selenium-id": props['data-selenium-id'] || 'contact-sales-button',
        size: props.size,
        use: props.use,
        block: props.block,
        truncate: true,
        truncateStringProps: {
          justifyContent: 'center'
        },
        children: props._textOverride || /*#__PURE__*/_jsx(FormattedMessage, {
          message: "upgrades.contactSalesButton.text"
        })
      });
    }
  };
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [renderButton(), modalElement]
  });
};
export default withErrorBoundary(ContactSalesButton, {
  boundaryName: CONTACT_SALES_BUTTON
});